import React, { useEffect, useRef, useState } from 'react';
import './About.css';
import deliveryImage from '../assets/delivery.webp';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="about" id="apropos" ref={sectionRef}>
      <div className="section-container">
        <div className="about-grid">
          <div className={`about-content ${isVisible ? 'visible' : ''}`}>
            <span className="section-tag">À propos</span>
            <h2 className="section-title">Excellence en transport et placement</h2>
            <p className="about-text">
              CPT EXPRESS est une entreprise basée à Montréal spécialisée dans le transport, 
              la livraison/courrier, et le placement de chauffeurs. Nous offrons des solutions 
              rapides, fiables et sécurisées pour les entreprises et les particuliers ayant 
              besoin d'un soutien logistique efficace.
            </p>
            <p className="about-text">
              Notre mission est d'assurer des livraisons ponctuelles, un service professionnel, 
              et des chauffeurs qualifiés qui répondent aux plus hauts standards. Que ce soit 
              pour un petit colis, du transport commercial ou le recrutement de chauffeurs, 
              CPT EXPRESS garantit un service fluide du début à la fin.
            </p>
            <p className="about-text last">
              Nous nous distinguons par notre rapidité, professionnalisme, et notre approche 
              centrée sur le client, faisant de nous un partenaire de confiance dans la grande 
              région de Montréal.
            </p>
            <div className="values">
              <div className="value">
                <div className="value-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                </div>
                <div className="value-content">
                  <h4>Fiabilité</h4>
                  <p>Un service sur lequel vous pouvez toujours compter</p>
                </div>
              </div>
              <div className="value">
                <div className="value-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                  </svg>
                </div>
                <div className="value-content">
                  <h4>Efficacité</h4>
                  <p>Des solutions rapides et optimisées pour vos opérations</p>
                </div>
              </div>
              <div className="value">
                <div className="value-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                    <path d="M2 17l10 5 10-5"></path>
                    <path d="M2 12l10 5 10-5"></path>
                  </svg>
                </div>
                <div className="value-content">
                  <h4>Professionnalisme</h4>
                  <p>Une équipe dévouée à l'excellence du service</p>
                </div>
              </div>
            </div>
          </div>
          <div className={`about-visual ${isVisible ? 'visible' : ''}`}>
            <div className="about-image">
              <img src={deliveryImage} alt="Livraison CPT Express" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
